import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from './Store/store';
import { logued } from './Store/features/userStatusSlice/userStatusSlice';
import { populateCatNotificaciones } from './Store/features/Clientes/1868/CatNotificaciones';
import { BsSearch, BsFileEarmarkExcel, BsFileEarmarkPdf } from "react-icons/bs";
import {
  Container,
  Nav,
  Navbar,
  OverlayTrigger,
  Popover,
} from 'react-bootstrap';
import usuariosServices from './Services/Catalogos/Usuarios.Services';
import FService from './Componest/Cliente/Services/CatNotificaciones.Services';
import { IconContext } from 'react-icons';
import { BsPersonCircle } from 'react-icons/bs';
import './App.css';
import Submenu from './Componest/Submenu/Submenu';
import ItemMenu from './interfaces/Catalogos/IItemMenu';
import KioskoAsistencia from './Componest/Dashboard/KioskoAsistencia';

function App() {
  const [mainMenu, setMainMenu] = useState<ItemMenu[]>([]);
  const [userName, setUserName] = useState('');
  const userLogued = useSelector((state: RootState) => state.userStatus.value);
  const mCatNotificaciones = useSelector(
    (state: RootState) => state.CatNotificaciones.CatNotificaciones
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const updateUserName = () => {
    const storedUser = localStorage.getItem('User');
    setUserName(storedUser || 'Usuario');
  };

  const loadCatNotificaciones = () => {
    FService.Get()
      .then((response) => {
        dispatch(populateCatNotificaciones(response.data));
      })
      .catch(() => { });
  };

  useEffect(() => {
    usuariosServices
      .validate()
      .then((response) => {
        if (response.status === 200) {
          dispatch(logued(true));
          updateUserName();
          loadCatNotificaciones();
        }
      })
      .catch(() => {
        if (!window.location.href.indexOf('login')) {
          localStorage.clear();
          dispatch(logued(false));
          navigate('/login');
        }
      });
  }, [dispatch, navigate]);

  useEffect(() => {
    updateUserName();
  }, [userLogued]);

  useEffect(() => {
    const menu = localStorage.getItem('menu');
    if (menu && userLogued) {
      setMainMenu(JSON.parse(menu));
    } else {
      setMainMenu([]);
    }
  }, [userLogued]);

  const handleLogout = () => {
    localStorage.clear();
    dispatch(logued(false));
    setMainMenu([]);
    navigate('/login');
  };

  const handleForgotPassword = () => {
    navigate('/forgot-password');
  };

  

  const goToUserDashboard = () => navigate('/usuario-dashboard');

  return (
    <div className="App">
      <Navbar expand="lg" className="modern-navbar">
        <Container>
          <Navbar.Brand href="/" className="brand-logo">
            RHUSA
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" className="border-0" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              {mainMenu
                ? mainMenu.map((itemMenu) => {
                  if (itemMenu.padreId === 0) {
                    return (
                      <Submenu
                        descripcion={itemMenu.descripcion}
                        key={itemMenu.id}
                        allItems={mainMenu}
                        submenu={mainMenu.filter(
                          (item) => item.padreId === itemMenu.id
                        )}
                      />
                    );
                  }
                  return null;
                })
                : ''}
            </Nav>
            <Nav className="align-items-center gap-3">
              {!userLogued ? (
                <>
                  <Nav.Link className="nav-btn" onClick={() => navigate('/login')}>
                    Login
                  </Nav.Link>
                  {/* <Nav.Link className="nav-btn" onClick={handleForgotPassword}>
                    Forgot Password
                  </Nav.Link> */}
                </>
              ) : (
                <>
                  {/* <Nav.Link className="nav-btn" href="/help">
                    Help
                  </Nav.Link> */}

                  



                                  <Nav.Link
                  className="nav-btn"
                  onClick={() => {
                    const link = document.createElement('a');
                    link.href = "/manual-rhmex.pdf"; 
                    link.download = "Manual_RHMEX.pdf";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                  }}
                >
                 <BsFileEarmarkPdf /> Manual
                </Nav.Link>

                
                                  {/* <Nav.Link className="nav-btn" onClick={() => navigate('/kiosko-asistencia')}>
                                        Kiosko
                                      </Nav.Link> */}

                  <Nav.Link className="nav-btn" onClick={handleLogout}>
                    Logout
                  </Nav.Link>
                  <div className="user-card" onClick={goToUserDashboard}>
                    <IconContext.Provider value={{ size: '25px', color: '#FFFFFF' }}>
                      <BsPersonCircle />
                    </IconContext.Provider>
                    <span className="username">{userName}</span>
                  </div>
                  <div
                    style={{
                      position: 'relative',
                      visibility:
                        mCatNotificaciones.filter((n) => n.activo).length > 0
                          ? 'visible'
                          : 'hidden',
                    }}
                  >
                    <OverlayTrigger
                      trigger="click"
                      placement="left"
                      overlay={
                        <Popover id="popover-basic">
                          <Popover.Header as="h3" className="notif-header">
                            Adminusa les informa
                          </Popover.Header>
                          <Popover.Body>
                            {mCatNotificaciones
                              ? mCatNotificaciones
                                .filter((n) => n.activo)
                                .map((n) => (
                                  <div key={n.id} className="notif-item">
                                    {n.mensaje}
                                  </div>
                                ))
                              : ''}
                          </Popover.Body>
                        </Popover>
                      }
                    >
                      <div className="notification-bell">
                        <div className="circle pulse"></div>
                      </div>
                    </OverlayTrigger>
                  </div>
                </>
              )}






            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <Outlet />

      {/* 🎨 Estilos modernos */}
      <style>{`
        .modern-navbar {
          background: linear-gradient(120deg, #700acaff, #187FE6, #00C9FF);
          background-size: 200% 200%;
          animation: gradientShift 6s ease infinite;
          box-shadow: 0 6px 20px rgba(0,0,0,0.15);
          border-radius: 0 0 20px 20px;
          padding: 8px 0;
        }
        @keyframes gradientShift {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        .brand-logo {
          font-size: 1.6rem;
          font-weight: bold;
          color: #fff;
          letter-spacing: 1px;
        }
        .nav-btn {
          color: #fff !important;
          font-weight: 500;
          padding: 6px 14px;
          border-radius: 25px;
          background: rgba(255,255,255,0.1);
          transition: all 0.3s ease;
        }
        .nav-btn:hover {
          background: rgba(255,255,255,0.25);
          color: #FFE082 !important;
          transform: translateY(-2px);
        }
        .user-card {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 6px 14px;
          border-radius: 30px;
          background: rgba(255,255,255,0.1);
          cursor: pointer;
          transition: 0.3s;
        }
        .user-card:hover {
          background: rgba(255,255,255,0.25);
        }
        .username {
          color: #fff;
          font-weight: 500;
        }
        .notification-bell {
          width: 26px;
          height: 26px;
          border-radius: 50%;
          background: #ff4d4f;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          box-shadow: 0 0 10px rgba(255,77,79,0.6);
          transition: transform 0.2s;
        }
        .notification-bell:hover {
          transform: scale(1.1);
        }
        .circle.pulse {
          width: 12px;
          height: 12px;
          background: white;
          border-radius: 50%;
          animation: pulse 1.5s infinite;
        }
        @keyframes pulse {
          0% { transform: scale(0.9); opacity: 0.7; }
          50% { transform: scale(1.2); opacity: 1; }
          100% { transform: scale(0.9); opacity: 0.7; }
        }
        .notif-header {
          background: #187FE6;
          color: #fff;
          font-weight: bold;
        }
        .notif-item {
          padding: 6px 0;
          border-bottom: 1px solid #eee;
          font-size: 0.9rem;
        }
      `}</style>
    </div>
  );
}

export default App;
